import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="main-footer">
      <span>&copy; 2023. Vindr. All Rights Reserved.</span>
      <span>Created by: <Link to="https://www.voi-communication.com" target="_blank">VOI-Communication</Link></span>
    </div>
  )
}